import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  setCardsToRender,
  setMapCardData,
  STATIC_LAYERS_CARD,
} from '@rsos/reduxDataStore/src/features/mapCard/mapCardSlice';
import useDebounce from '@rsos/utils/useDebounce';
import { baseSpatialLayerSelector } from '../../SpatialLayers/selectors';
import { showPopover, hidePopover } from '../MapPopover/mapPopoverSlice';
import StaticLayerGL from './StaticLayerGL';

export const BaseStaticLayersGL = ({
  overlay,
  isMapIconDisabled,
  onMarkerClick,
}) => {
  const [activeMarkerId, setActiveMarkerId] = useState(null);

  const { staticLayersCard } = useSelector(state => state?.mapCard?.cards);

  const dispatch = useDispatch();

  const handleMarkerClick = (spatialObject, spatialLayer) => {
    setActiveMarkerId(spatialObject.id);
    if (onMarkerClick) {
      onMarkerClick(spatialObject, spatialLayer);
    } else {
      dispatch(
        setMapCardData({
          layerData: spatialLayer,
          spatialObject,
        }),
      );
      dispatch(setCardsToRender(STATIC_LAYERS_CARD));
    }
  };

  const baseSpatialLayers = useSelector(state => {
    return baseSpatialLayerSelector(state.spatialLayers.staticLayers);
  });

  useEffect(() => {
    if (!staticLayersCard) {
      setActiveMarkerId(null);
    }
  }, [staticLayersCard]);

  const handleMarkerHover = useDebounce(
    o => {
      if (o) {
        const pop = {
          spatialLayerKey: o.spatialObject?.external_id,
          spatialLayer: o.spatialLayer,
          spatialObject: o.spatialObject,
        };
        dispatch(showPopover(pop));
      } else {
        dispatch(hidePopover());
      }
    },
    100,
    [],
  );

  return (
    <>
      {baseSpatialLayers.map((spatialLayer, i) => {
        return (
          <StaticLayerGL
            key={`${spatialLayer.id}-${i}`}
            overlay={overlay}
            spatialLayer={spatialLayer}
            activeMarkerId={activeMarkerId}
            onClick={handleMarkerClick}
            onHover={handleMarkerHover}
            isMapIconDisabled={isMapIconDisabled}
          />
        );
      })}
    </>
  );
};
